import { observer } from 'mobx-react-lite'
import './index.scss'
import XImg from '@assets/svg/x.svg'
import { Context } from '@/index'
import { useContext } from 'react'
import ProfilePlaceholder from '../../assets/img/profile-placeholder.jpg';
import StarSvg from '../../assets/svg/star.svg';
// import { assignTask as assignTaskApi } from '@api/task-api';
import config from '@/config';

const DeclineFreelancer = observer(({ taskId, declinedUser, taskName, callGetTask }) => {
    const { modal } = useContext(Context);

    const declineTask = () => {
        console.log('decline');
        // const obj = {
        //     assigned_user_id: assignedUser.id
        // }
        // assignTaskApi(taskId, obj)
        // .then((res) => {
        //     console.log(res);
        //     callGetTask();
        //     modal.closeModal();
        // })
        // .catch((error) => {
        //     console.log(error);
        // })
    }
    
    return (
        <div className="decline-freelancer">
            <div className="header-modal">
İcraçını rədd et
                <div className="x-block" onClick={() => modal.closeModal()}>
                    <img src={XImg} className="x" alt="close"/>
                </div>
            </div>
            <div className="user">
                <div className="user-img">
                    <img src={declinedUser.image ? config.strapi.image_url + '/' + declinedUser.image : ProfilePlaceholder} />
                </div>
                <div className="user-info">
                    <div className="user-content">
                        <div className="user-name">{`${declinedUser.first_name} ${declinedUser.last_name}`}</div>
                        <div className="profession-rating">
                            <div className="profession">{declinedUser.specialization ? declinedUser.specialization : 'İcraçı'}</div>
                            <div className="rating">
                                <img src={StarSvg} />
                                <span>{declinedUser.rating >= 0 ? declinedUser.rating.toFixed(1) : '0.0' }</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text">
Bu mütəxəssisin sifariş üzərində işləmək üçün təklifini rədd etmək istədiyinizi təsdiq edin
                <span className="task-name">
                    {` ${taskName}`}
                </span>
            </div>
            <div className="actions">
                <button className="cancel" onClick={() => modal.closeModal()} >
Ləğv et
                </button>
                <button className="confirm" onClick={declineTask}>
Rədd et
                </button>
            </div>
        </div>
    )
})

export { DeclineFreelancer }